import { createFileRoute } from '@tanstack/react-router'
import { HelpGuideScreen } from '../../../features/help/screens'
import { helpGuidesQuery } from '../../../features/help/use-help'
import { helpViewerQuery } from '../../../features/help/viewer'

/**
 * /help/<section>/<slug>. Contractor guides open for anyone; a staff guide opens only for a staff session and is a
 * 404 for everyone else. Owner: slice 36 `web-help-centre`.
 */
export const Route = createFileRoute('/help/$section/$slug')({
  loader: async ({ context }) => {
    const viewer = await context.queryClient.ensureQueryData(helpViewerQuery())
    await context.queryClient.ensureQueryData(helpGuidesQuery(viewer))
  },
  component: GuideRoute,
})

function GuideRoute() {
  const { section, slug } = Route.useParams()
  return <HelpGuideScreen section={section} slug={slug} />
}
